import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import Navbar from "../components/Layouts/Navbar";
import HeroBanner from '../components/Common/HeroBanner';
import DButton from '../components/elements/DButton';
import Breadcrumb from '../components/Layouts/Breadcrumb';
import SectionHeading from "../components/Common/SectionHeading";
import Head from 'next/head';
import axios from 'axios';
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));


const CancellationPolicy = () =>  {

  const [scrolled, setScrolled] = useState(0)
  const [scrolledStatus, setScrolledStatus] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset);
    // clean up code
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (scrolled > 30) {
      setScrolledStatus(true)
    }
  }, [scrolled])

  return (
    <>
      
      
      <Navbar />
      <>
        <HeroBanner
          background={process.env.IMG_CDN + "img/banner/cancellation-policy.webp"}
          title={<>DelveInsight&apos;s Cancellation Policy</>}
        />
        <Breadcrumb />
        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-10 my-6">
          <SectionHeading
            title="Welcome to DelveInsight&apos;s Cancellation Policy"
          />
          <div className='grid grid-cols-12'>
            <div className='col-span-12'>
              <div className='text-justify'>
                <p>DelveInsight Business and Market Research offer its clients full-service, customized market assessment. We set ourselves apart by exceeding our client’s expectations through a combination of high-quality, industry-specific marketing consultation, primary research, and analytical expertise at reasonable prices.</p>
                <p>We provide sample pages for all the extensive reports and case studies as per the client’s needs in PDF format. Once the order is placed and has been dispatched, there is no cancellation.</p>
                <p>However, if the client made the payment by mistake and wants to cancel the order before the delivery, it is subject to the discretion of the management or the concerned department.</p>
                <p>If you require any further assistance, we are always willing to assist you.</p>
              </div>
            </div>
          </div>
        </div>
      </>
      {scrolledStatus && <>
        <Footer />
      </>}

    </>
  )
}

CancellationPolicy.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
      const response = await axios.get(process.env.API_URL + '/meta' + slugData);
      return {
          title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}

export default CancellationPolicy;
